<template>
  <div class="lottery-dantuo-container">
    <h1>彩票胆拖组合工具</h1>
    
    <div class="lottery-selector">
      <el-select v-model="currentLottery" placeholder="请选择彩票类型" @change="clearAll">
        <el-option label="双色球红球" value="ssq"></el-option>
        <el-option label="大乐透前区" value="dlt"></el-option>
      </el-select>
    </div>

    <!-- 双色球红球部分 -->
    <div v-if="currentLottery === 'ssq'" class="selection-area">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>红球胆码选择</span>
          <el-tag type="warning" style="margin-left: 10px;">最多选择5个胆码</el-tag>
        </div>
        <div class="ball-area">
          <div 
            v-for="n in 33" 
            :key="'ssq-red-'+n" 
            class="ball red"
            :class="{selected: redDanma.includes(n)}"
            @click="toggleRedDanma(n)"
          >
            {{ n < 10 ? '0'+n : n }}
          </div>
        </div>
      </el-card>

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>红球拖码选择</span>
          <el-tag type="info" style="margin-left: 10px;">至少选择1个拖码</el-tag>
        </div>
        <div class="ball-area">
          <div 
            v-for="n in 33" 
            :key="'ssq-red-tuo-'+n" 
            class="ball red"
            :class="{selected: redTuoma.includes(n), disabled: redDanma.includes(n)}"
            @click="toggleRedTuoma(n)"
          >
            {{ n < 10 ? '0'+n : n }}
          </div>
        </div>
      </el-card>
    </div>

    <!-- 大乐透前区部分 -->
    <div v-if="currentLottery === 'dlt'" class="selection-area">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>前区胆码选择</span>
          <el-tag type="warning" style="margin-left: 10px;">最多选择4个胆码</el-tag>
        </div>
        <div class="ball-area">
          <div 
            v-for="n in 35" 
            :key="'dlt-front-'+n" 
            class="ball front"
            :class="{selected: frontDanma.includes(n)}"
            @click="toggleFrontDanma(n)"
          >
            {{ n < 10 ? '0'+n : n }}
          </div>
        </div>
      </el-card>

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>前区拖码选择</span>
          <el-tag type="info" style="margin-left: 10px;">至少选择1个拖码</el-tag>
        </div>
        <div class="ball-area">
          <div 
            v-for="n in 35" 
            :key="'dlt-front-tuo-'+n" 
            class="ball front"
            :class="{selected: frontTuoma.includes(n), disabled: frontDanma.includes(n)}"
            @click="toggleFrontTuoma(n)"
          >
            {{ n < 10 ? '0'+n : n }}
          </div>
        </div>
      </el-card>
    </div>

    <div class="control-area">
      <el-button type="primary" @click="generateCombinations" :disabled="!canGenerate">生成组合</el-button>
      <el-button @click="clearAll">清空选择</el-button>
      <el-button type="success" @click="exportCombinations" :disabled="combinations.length === 0">导出结果</el-button>
    </div>

    <div class="result-area" v-if="combinations.length > 0">
      <el-card class="result-card">
        <div slot="header" class="clearfix">
          <span>组合结果</span>
          <el-tag type="success" style="margin-left: 10px;">共 {{ combinations.length }} 注;</el-tag>
          <el-tag type="danger" style="margin-left: 10px;">金额 ￥{{ totalCost }} 元</el-tag>
        </div>
        <div class="combination-list">
          <div 
            v-for="(combo, index) in combinations" 
            :key="`combo-${currentLottery}-${index}`" 
            class="combination-item"
          >
            <span class="combo-index">{{ index + 1 }}.</span>
            <template v-if="currentLottery === 'ssq'">
              <span class="red-balls">
                <span 
                  v-for="(ball, ballIndex) in combo" 
                  :key="`combo-red-${index}-${ballIndex}`" 
                  class="ball red small"
                >
                  {{ ball < 10 ? '0'+ball : ball }}
                </span>
              </span>
            </template>
            <template v-else>
              <span class="front-balls">
                <span 
                  v-for="(ball, ballIndex) in combo" 
                  :key="`combo-front-${index}-${ballIndex}`" 
                  class="ball front small"
                >
                  {{ ball < 10 ? '0'+ball : ball }}
                </span>
              </span>
            </template>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LotteryDanTuo',
  data() {
    return {
      currentLottery: 'ssq',
      redDanma: [],
      redTuoma: [],
      frontDanma: [],
      frontTuoma: [],
      combinations: []
    }
  },
  computed: {
    canGenerate() {
      if (this.currentLottery === 'ssq') {
        const redDanmaCount = this.redDanma.length
        const redTuomaCount = this.redTuoma.length
        return redDanmaCount >= 1 && 
               redDanmaCount <= 5 && 
               redTuomaCount >= 1 && 
               (redDanmaCount + redTuomaCount) >= 6
      } else {
        const frontDanmaCount = this.frontDanma.length
        const frontTuomaCount = this.frontTuoma.length
        return frontDanmaCount <= 4 && 
               frontTuomaCount >= 1 && 
               (frontDanmaCount + frontTuomaCount) >= 5
      }
    },
    totalCost() {
      // 双色球和大乐透每注都是2元
      return this.combinations.length * 2
    }
  },
  methods: {
    toggleRedDanma(n) {
      const index = this.redDanma.indexOf(n)
      if (index === -1) {
        if (this.redDanma.length < 5) {
          this.redDanma.push(n)
          this.redDanma.sort((a, b) => a - b)
        } else {
          this.$message.warning('最多只能选择5个胆码')
        }
      } else {
        this.redDanma.splice(index, 1)
      }
    },
    toggleRedTuoma(n) {
      if (this.redDanma.includes(n)) return
      const index = this.redTuoma.indexOf(n)
      if (index === -1) {
        this.redTuoma.push(n)
        this.redTuoma.sort((a, b) => a - b)
      } else {
        this.redTuoma.splice(index, 1)
      }
    },
    toggleFrontDanma(n) {
      const index = this.frontDanma.indexOf(n)
      if (index === -1) {
        if (this.frontDanma.length < 4) {
          this.frontDanma.push(n)
          this.frontDanma.sort((a, b) => a - b)
        } else {
          this.$message.warning('最多只能选择4个胆码')
        }
      } else {
        this.frontDanma.splice(index, 1)
      }
    },
    toggleFrontTuoma(n) {
      if (this.frontDanma.includes(n)) return
      const index = this.frontTuoma.indexOf(n)
      if (index === -1) {
        this.frontTuoma.push(n)
        this.frontTuoma.sort((a, b) => a - b)
      } else {
        this.frontTuoma.splice(index, 1)
      }
    },
    clearAll() {
      if (this.currentLottery === 'ssq') {
        this.redDanma = []
        this.redTuoma = []
      } else {
        this.frontDanma = []
        this.frontTuoma = []
      }
      this.combinations = []
    },
    generateCombinations() {
      if (!this.canGenerate) return
      this.combinations = []
      
      if (this.currentLottery === 'ssq') {
        const redDanmaCount = this.redDanma.length
        const needSelectFromTuoma = 6 - redDanmaCount
        const redCombinations = this.getCombinations(this.redTuoma, needSelectFromTuoma)
        redCombinations.forEach(redCombo => {
          this.combinations.push([...this.redDanma, ...redCombo].sort((a, b) => a - b))
        })
      } else {
        const frontDanmaCount = this.frontDanma.length
        const needSelectFromFrontTuoma = 5 - frontDanmaCount
        const frontCombinations = this.getCombinations(this.frontTuoma, needSelectFromFrontTuoma)
        frontCombinations.forEach(frontCombo => {
          this.combinations.push([...this.frontDanma, ...frontCombo].sort((a, b) => a - b))
        })
      }
    },
    getCombinations(arr, k) {
      const result = []
      function backtrack(start, current) {
        if (current.length === k) {
          result.push([...current])
          return
        }
        for (let i = start; i < arr.length; i++) {
          current.push(arr[i])
          backtrack(i + 1, current)
          current.pop()
        }
      }
      backtrack(0, [])
      return result
    },
    exportCombinations() {
      let content = `${this.currentLottery === 'ssq' ? '双色球红球' : '大乐透前区'}胆拖组合结果\n\n`
      
      if (this.currentLottery === 'ssq') {
        content += `红球胆码: ${this.redDanma.map(n => n < 10 ? '0'+n : n).join(', ')}\n`
        content += `红球拖码: ${this.redTuoma.map(n => n < 10 ? '0'+n : n).join(', ')}\n\n`
        content += '组合结果:\n'
        this.combinations.forEach((combo, index) => {
          const redStr = combo.map(n => n < 10 ? '0'+n : n).join(' ')
          content += `${index + 1}. ${redStr}\n`
        })
      } else {
        content += `前区胆码: ${this.frontDanma.map(n => n < 10 ? '0'+n : n).join(', ')}\n`
        content += `前区拖码: ${this.frontTuoma.map(n => n < 10 ? '0'+n : n).join(', ')}\n\n`
        content += '组合结果:\n'
        this.combinations.forEach((combo, index) => {
          const frontStr = combo.map(n => n < 10 ? '0'+n : n).join(' ')
          content += `${index + 1}. ${frontStr}\n`
        })
      }
      
      content += `\n共 ${this.combinations.length} 注; 金额 ￥${this.totalCost} 元`
      
      const blob = new Blob([content], { type: 'text/plain;charset=utf-8' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `${this.currentLottery === 'ssq' ? '双色球红球' : '大乐透前区'}胆拖组合.txt`
      link.click()
      URL.revokeObjectURL(url)
    }
  }
}
</script>

<style scoped>
.lottery-dantuo-container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
  font-family: "Microsoft YaHei", sans-serif;
}

h1 {
  text-align: center;
  color: #f44336;
  margin-bottom: 20px;
}

.lottery-selector {
  text-align: center;
  margin-bottom: 30px;
}

.box-card {
  margin-bottom: 20px;
}

.ball-area {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.ball {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: bold;
  user-select: none;
  transition: all 0.3s;
}

.ball.red, .ball.front {
  background-color: #f8f8f8;
  color: #f44336;
  border: 1px solid #f44336;
}

.ball.selected.red, 
.ball.selected.front {
  background-color: #f44336;
  color: white;
}

.ball.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  text-decoration: line-through;
}

.ball.small {
  width: 28px;
  height: 28px;
  font-size: 12px;
}

.control-area {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 30px 0;
}

.result-area {
  margin-top: 30px;
}

.combination-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 10px;
}

.combination-item {
  display: flex;
  align-items: center;
  padding: 5px;
  border-bottom: 1px dashed #eee;
}

.combo-index {
  margin-right: 10px;
  color: #666;
  width: 30px;
}

.red-balls, .front-balls {
  display: flex;
  gap: 5px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
</style>


// WEBPACK FOOTER //
// src/views/usingTools/dragNum.vue